module.exports = __webpack_public_path__ + "img/swki.f39a9d17.jpg";